import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { ProbeStock } from 'entities/probe_stock'
import { ReactNode, useMemo } from 'react'
import { Badge } from 'react-bootstrap'
import { Form } from 'utils/hooks'
import { toDateText } from 'utils/util'

export const probeStockColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            {
                name: 'Well',
                th: true,
                width: 80,
                align: 'center',
                form: form,
                orderAttr: 'probe_stock_well',
                searchType: { name: 'well', type: 'text' },
            },
            {
                name: 'Tube ID',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'probe_stock_vial_id',
                searchType: { name: 'vialId', type: 'text' },
            },
            {
                name: 'Lot number',
                th: true,
                width: 130,
                form: form,
                orderAttr: 'probe_stock_lot_number',
                searchType: { name: 'lotNumber', type: 'text' },
            },
            {
                name: 'Inspect date',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'probe_stock_created_at',
                searchType: { name: 'createdAt', type: 'date' },
            },
            {
                name: 'Status',
                th: true,
                width: 100,
            },
            {
                name: 'Opened date',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'probe_stock_opened_date',
                searchType: { name: 'opened_date', type: 'date' },
            },
            {
                name: 'Used date',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'probe_stock_used_date',
                searchType: { name: 'used_date', type: 'date' },
            },
            {
                name: 'Expiration date',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'probe_stock_expiration_date',
                searchType: { name: 'part_number', type: 'text' },
            },
            {
                name: 'Probe',
                th: true,
                minWidth: 150,
                form: form,
                orderAttr: 'probe_stock_probe_name',
                searchType: { name: 'probe_name', type: 'text' },
            },
            {
                name: 'Box',
                th: true,
                minWidth: 100,
                form: form,
                orderAttr: 'probe_box',
                searchType: { name: 'probe_box', type: 'text' },
            },
            {
                name: 'Assay ID',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'probe_stock_assay_id',
                searchType: { name: 'probe_name', type: 'text' },
            },
        ],
    }
}

export type ProbeStockTableDataProps = {
    probeStock?: ProbeStock
    displaySetting: DisplaySetting
}

export const ProbeStockTableData = ({ probeStock, displaySetting }: ProbeStockTableDataProps): JSX.Element => {
    if (!probeStock) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell align="center">{probeStock.well}</TableCell>
                <TableCell>{probeStock.vialId}</TableCell>
                <TableCell>{probeStock.lotNumber}</TableCell>
                <TableCell>{toDateText(probeStock.createdAt)}</TableCell>
                <TableCell>
                    {probeStock.usedDate ? (
                        <Badge bg="success">使用済</Badge>
                    ) : probeStock.openedDate ? (
                        <Badge bg="primary">開封済</Badge>
                    ) : (
                        <Badge bg="secondary">未使用</Badge>
                    )}
                </TableCell>
                <TableCell>{probeStock.openedDate}</TableCell>
                <TableCell>{probeStock.usedDate}</TableCell>
                <TableCell>{probeStock.expirationDate}</TableCell>
                <TableCell>{probeStock.probeName}</TableCell>
                <TableCell>{probeStock.probe?.box}</TableCell>
                <TableCell>{probeStock.assayId}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
